import { USER_TYPE } from 'constants/userTypes'
import { IUserPermissions, IShipmentPermission } from './auth'

export enum USER_ROLES {
  admin = 'admin',
  employee = 'employee',
}

export interface IUserGroup {
  id: number
  key: string
  name: string
  email: string
}

export interface ICurrentUserState {
  error?: string | null
  isFetching: boolean
  userDetails: {
    applicationId: string
    applicationType?: string
    id: number
    userType: USER_TYPE
    email: string
    groups: IUserGroup[]
    firstName?: string
    lastName?: string
    hasFleetPlannerAccess: boolean
    hasTmsAccess: boolean
    parentUserId: string
    role?: USER_ROLES
  }
  shipmentPermissions?: IShipmentPermission
  userPermissions: IUserPermissions
}

export interface IUser {
  id: string
  parentUserId: string
  firstName: string
  lastName: string
  createdAt: string
  email?: string
  phone: string
  cellPhone?: string
  phoneExt?: string
  role: string
  roleName: string
  userType: string
  userTypes: string[]
  userTypeName: string
  stateName: string
  lastLocationTime: string
  companyType: string
  companyId: string // TODO: Fix this... it should be a number
  companyName: string
  applicationId: string
  applicationType: string
  shipperApplicationId?: string
  carrierApplicationId?: string
  hasFleetPlannerAccess: boolean
  isPro?: boolean
  redirectToFp: boolean
  redirectToTms: boolean
  groups: IUserGroup[]
  userAvailability?: {
    isAvailable: boolean
  } | null
}

export interface IUserDetails extends Omit<IUser, 'id'> {
  id: number
  groups: IUserGroup[]
  hasFleetPlannerAccess: boolean
  hasTmsAccess: boolean
  inCarrierHomepageCohort?: boolean
}

export interface IUsersState {
  firstLoad: boolean
  fetching: boolean
  list: IUser[]
  error?: string
  count?: number
  totalCount?: number
}

export interface IManager {
  fullName: string
  relationshipType?: string
  tooltip?: string
  isTransfixAdmin?: boolean
}
